<template>
    <router-view></router-view>
</template>

<script>
import { mapGetters,mapActions, mapState } from 'vuex';
import i18n from './plugins/i18n';

export default {
    name: 'App',
    components: {
        
        
    },

    data: () => ({

    }),
    computed: {
        ...mapGetters('authentication', ["loggedIn"]),
        ...mapState('authentication', ['authorizations'])
    },
    methods: {
        ...mapActions('authentication', ["getCurrentUser"]),
        ...mapActions('authentication', ['fetchModules', 'fetchPermissions']),
        async createDataFetch() {
            await Promise.all([this.fetchModules(), this.getCurrentUser(), this.fetchPermissions()]);
        },
        setLocale() {
            let rtl = localStorage.getItem("rtl");
            let locale = localStorage.getItem("locale") || "en";
            this.$vuetify.rtl = rtl == "true" ? true : false;
            i18n.locale = locale;
        }
    },
    created () {
        this.createDataFetch();
        this.setLocale();
    },
    updated() {
        
    }
};
</script>

<style >
  @font-face {
    font-family: 'Cairo';
    src: url('./assets/font/Cairo-Regular.ttf');
  }
</style>
